import React from "react";
import SingleCheckbox from "@/components/ui/SingleCheckbox";
import { ControlProps } from "../types";

export const CheckboxControl: React.FC<ControlProps> = ({
  config,
  value,
  onChange,
  name
}) => (
  <SingleCheckbox
    id={name}
    label={config?.checkboxInlineText ?? ""}
    isChecked={value === true}
    onCheckedChange={(checked) => onChange(checked === true)}
  />
);
